import { jsx as _jsx } from "react/jsx-runtime";
import pearBlueUrl from '../../../assets/gems/pear_blue.svg?inline';
export function PearBlue({ ...props }) {
    return _jsx("img", { ...props, src: pearBlueUrl, alt: 'PearBlueImage' });
}
